import React, { FC } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import styles from './Faq.module.scss';
import Spinner from '../../../shared/Spinner/Spinner';
import { useStaticPageQuery } from 'src/hooks/query';

const Faq: FC = () => {
  const { html, isLoading } = useStaticPageQuery('faq');

  if (isLoading) {
    return (
      <Container>
        <Spinner />
      </Container>
    );
  }

  return (
    <Container>
      <Row>
        <Col sm={12}>
          <div className={styles.faqContent} dangerouslySetInnerHTML={html} />
        </Col>
      </Row>
    </Container>
  );
};

export default Faq;
